<template>
  <div>
    <!-- <div class="mt-5 search-container w-100">
      <input
        type="search"
        class="search-input"
        :style="{ border: `1px solid ${getPrimaryColor()}` }"
        placeholder="Enter Location"
        v-model="searchLocation"
      />
      <a-button
        :loading="loading"
        type="submit"
        class="search-button font-white primary-button"
        :style="{
          border: '1px solid ' + getPrimaryColor(),
          background: getPrimaryColor()
        }"
        @click="getPeople()"
      >
        <a-icon class="svg-icon-size" type="search" :size="'large'" />
      </a-button>
    </div> -->
    <div class="mt-3 filters-section text-left " v-if="showFilters">
      <span
        class="bold-text cp"
        @click="() => (hideFiltersToggle = !hideFiltersToggle)"
        ><u>{{ !hideFiltersToggle ? "Show" : "Hide" }} Filters</u></span
      >
      <span
        :style="{ color: getPrimaryColor() }"
        class="ml-5 hyper-link cp"
        v-if="hideFiltersToggle"
        @click="clearFilters()"
        >Clear Filters</span
      >

      <div
        class="filters-cont"
        v-bind:class="!hideFiltersToggle ? 'transparent' : ''"
      >
        <div class="row mt-4">
          <div class="col-12 col-md-4 text-center pb-2">
            <p class="m-0">
              <label for="age" class="mb-1 font-weight-bold"
                >Type of {{ currentCircle.condition_type }}</label
              >
            </p>
            <a-select
              :size="'large'"
              class="w-100"
              placeholder="Select category"
              style="width: 120px"
              v-model="ibs"
            >
              <a-select-option
                :value="disease.display_name"
                v-for="disease in circleDiseaseTypes"
                :key="disease.id"
                >{{ disease.display_name }}</a-select-option
              >
            </a-select>
          </div>
          <div class="col-12 col-md-4 text-center">
            <p class="m-0">
              <label for="age" class="mb-1">Age</label>
            </p>
            <a-select
              size="large"
              class="w-100"
              placeholder="Select Age"
              @change="getPeople()"
              v-model="searchAge"
            >
              <a-select-option value="">Select</a-select-option>
              <a-select-option value="10">0-10</a-select-option>
              <a-select-option value="20">11-20</a-select-option>
              <a-select-option value="30">21-30</a-select-option>
              <a-select-option value="40">31-40</a-select-option>
              <a-select-option value="50">41-50</a-select-option>
              <a-select-option value="60">51-60</a-select-option>
              <a-select-option value="70">61-70</a-select-option>
              <a-select-option value="80">71-80</a-select-option>
              <a-select-option value="90">81-90</a-select-option>
              <a-select-option value="100">91-100</a-select-option>
            </a-select>
          </div>
          <div class="col-12 col-md-4 text-center">
            <label for="username" class="mb-1">Username</label>
            <br />
            <a-input
              size="large"
              placeholder="Username"
              v-model="searchUserName"
              class="w-100 primary-input-height"
              @keyup="getPeople()"
            />
          </div>
          <div class="ml-3 text-center">
            <p class="m-0">
              <label for="gender" class="mb-1">Gender</label>
            </p>
            <label class="text-center radio-btn" for="maleRadio">
              <input
                id="maleRadio"
                class="primary-input-height w-100"
                type="radio"
                name="gender"
                value="male"
                v-model="searchGender"
                @change="getPeople()"
              />
              <div
                class="input-placeholder male cp py-1 px-4"
                :style="{
                  border: `1px solid ${getPrimaryColor()}`,
                  background: `${
                    searchGender === 'male' ? getPrimaryColor() : ''
                  }`
                }"
              >
                <span
                  :style="
                    searchGender === 'male' ? { color: 'white !important' } : {}
                  "
                  class="align-text-top"
                  >Male</span
                >
              </div>
            </label>
            <label class="text-center radio-btn" for="femaleRadio">
              <input
                id="femaleRadio"
                class="primary-input-height w-100"
                type="radio"
                name="gender"
                value="female"
                v-model="searchGender"
                @change="getPeople()"
              />
              <div
                class="input-placeholder female cp py-1 px-4"
                :style="{
                  border: `1px solid ${getPrimaryColor()}`,
                  background: `${
                    searchGender === 'female' ? getPrimaryColor() : ''
                  }`
                }"
              >
                <span
                  :style="
                    searchGender === 'female'
                      ? { color: 'white !important' }
                      : {}
                  "
                  class="align-text-top"
                  >Female</span
                >
              </div>
            </label>
            <label class="text-center radio-btn" for="otherRadio">
              <input
                id="otherRadio"
                class="primary-input-height w-100"
                type="radio"
                name="other"
                value="other"
                v-model="searchGender"
                @change="getPeople()"
              />
              <div
                class="input-placeholder other cp py-1 px-4"
                :style="{
                  border: `1px solid ${getPrimaryColor()}`,
                  background: `${
                    searchGender === 'other' ? getPrimaryColor() : ''
                  }`
                }"
              >
                <span
                  :style="
                    searchGender === 'other'
                      ? { color: 'white !important' }
                      : {}
                  "
                  class="align-text-top"
                  >Other</span
                >
              </div>
            </label>
          </div>
        </div>
      </div>
    </div>
    <div class="doctors-search-result">
      <div id="cards-section-top"></div>
      <p class="text-left m-0 mb-3 results" v-if="peopleList && !loading">
        <strong>{{ count }} Results</strong>
      </p>
      <div class="dropdownOptions text-right">
          <a-dropdown>
         <a class="ant-dropdown-link" @click.prevent>
        Show {{options}}
       <DownOutlined />
    </a>
    <template #overlay>
      <a-menu @click="options">
        <a-menu-item key="Newest First">Newest First</a-menu-item>
        <a-menu-item key="Oldest First">Oldest First</a-menu-item>
        <a-menu-item key="Most Popular">Most Popular</a-menu-item>
        <a-menu-item key="Nearest to you">Nearest to you</a-menu-item>
      </a-menu>
    </template>
  </a-dropdown>
       </div>
    
      <div class="row">
        <div
          class="col-md-12 col-lg-12 col-sm-12 col-xs-12 mb-3"
          v-for="people in peopleList"
          :key="people.id"
        >
          <div class="claim-card">
            <div class="user-name d-flex  p-3"> 
              <a
                @click="viewProfile(people)"
                class="bg-img d-block background-image mr-3"
              >
                <!-- <a-avatar :size="100" :src="people.url" alt="" /> -->
                <a-avatar
                  :style="{
                    color: ' #ffffff !important',
                    'background-color': people.url
                      ? people.url
                      : ''
                      ? ''
                      : '#C997C5'
                  }"
                  :size="70"
                  :src="people.url"
                  class="text-capitalize"
                >
                  {{
                    people.firstName
                      ? people.firstName[0]
                      : people.display_name
                      ? people.display_name[0]
                      : people.first_name[0]
                  }}
                </a-avatar>
              </a>
              <hr class="divider">
              <div class="right-items patient-interests">
                <div
                  class="d-inline-block text-left ml-2 align-self-center overflow-hidden"
                >
                  <p
                    class="m-0 bold-text text-truncate cp"
                    @click="viewProfile(people)"
                  >
                    {{ people.display_name }}
                  </p>
                  <p
                    :style="{ color: '#777' }"
                    v-if="people.location && people.location[0].state"
                    class="m-0 doc-loc text-truncate"
                  >
                   <img src="../../../assets/images/addphy-location.png" />
                    {{ people.location[0].city }},
                    {{ people.location[0].state }}
                  </p>
                  <p
                    :style="{
                      color: getPrimaryColor(),
                      'font-size': '14px',
                      'line-height': '17px',
                      'font-weight': 'bold'
                    }"
                  >
                    {{ people.circle_member }} circle members
                  </p>
                </div>

                <div class="meet-others">
                  <button
                    :style="{
                      background:  getPrimaryColor(),
                      'pointer-events': 'all'
                    }"
                    class="dovemed-button font-white primary-button"
                    @click="viewProfile(people)"
                  >
                    <!-- {{ people.on_circle ? "In your circle" : "ADD TO CIRCLE" }} -->
                    View Profile
                    <i
                      v-if="people.on_circle"
                      class="fa fa-check"
                      aria-hidden="true"
                    ></i>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="text-center cp" v-if="!loading && !peopleList">
        No Results Found
      </div>
      <div v-if="peopleList" class="d-flex justify-content-center mb-3">
        <a-button
          @click="goToNext()"
          :style="{ background: getPrimaryColor() }"
          class="mx-auto dovemed-button font-white primary-button"
          v-if="
            peopleList.length !== 0 && limit * currentPage < count && !loading
          "
        >
          View More
        </a-button>
      </div>
    </div>
    <div v-if="loading" class="d-flex justify-content-center mt-3">
      <div>
        <div class="spinner-border position-absolute spinner-class"></div>
      </div>
      <div :style="{ 'margin-left': '-14px', 'margin-top': '40px' }">
        Loading...
      </div>
    </div>
  </div>
</template>

<script>
import { RepositoryFactory } from "../../../repositories/RepositoryFactory";
import { mapGetters } from "vuex";

const UserRepository = RepositoryFactory.get("user");
const AppRepository = RepositoryFactory.get("app");

export default {
  name: "MeetPeople",
  data() {
    return {
      loading: false,
      showFilters: false,
      hideFiltersToggle: false,
      searchLocation: "",
      searchGender: undefined,
      searchUserName: undefined,
      searchAge: undefined,
      ibs: "",
      peopleList: [],
      currentPage: 1,
      limit: 50,
      count: 0,
      options : "Newest First",
    };
  },
  

  mounted() {
    this.getPeople(this.currentPage);
    this.getIBS();
  },

  computed: {
    ...mapGetters({
      circleDiseaseTypes: "Circle/circleDiseaseTypes"
    })
  },

  methods: {
    clearFilters() {
      this.searchGender = "";
      this.searchUserName = "";
      this.searchLocation = "";
      this.searchAge = "";
      this.ibs = "";
      this.getPeople(this.currentPage);
    },

    goToNext() {
      this.currentPage = this.currentPage + 1;
      this.getPeople(this.currentPage);
    },

    /**
     * View other user profile
     */
    getIBS() {
      this.$store.dispatch("Circle/diseaseTypes", {
        type: this.currentCircle.id
      });
    },

    /**
     * View other user profile
     */
    viewProfile(user) {
      if (user.id === this.authUser.user.id) {
        this.routeToAuthProfile(this.authUser.user.role);
      } else {
        UserRepository.getOtherUserProfile(user, this.currentCircle.id)
          .then(res => {
            const data = {
              ...res.data.data.user_info,
              on_circle: res.data.data.on_circle,
              request_to_add: res.data.data.request_to_add
            };
            this.$store.commit("User/setViewUser", { data });
            switch (user.role) {
              case "doctor":
                this.$router
                  .push({
                    name: "ViewDoctorUpdates",
                    params: { id: user.id }
                  })
                  .catch(() => {});
                break;
              case "patient":
                this.$router
                  .push({
                    name: "ViewPatientUpdates",
                    params: { id: user.id }
                  })
                  .catch(() => {});
                break;
              case "caregiver":
                this.$router
                  .push({
                    name: "ViewPatientUpdates",
                    params: { id: user.id, role: 'caregiver' }
                  })
                  .catch(() => {});
                break;
              case "advocate":
                this.$router
                  .push({
                    name: "ViewAdvocateUpdates",
                    params: { id: user.id }
                  })
                  .catch(() => {});
                break;
              default:
                break;
            }
          })
          .catch(err => {});
      }
      // localStorage.setItem('__ou', JSON.stringify(data))
    },

    /**
     * Add Member to Circle
     */
    addMemberToCircle(user) {
      UserRepository.addToCircle(user, this.currentCircle.id)
        .then(res => {
          this.$notification.success({
            message: "Success",
            description: res.data.message
          });
          this.getPeople();
        })
        .catch(err => {
          this.$notification.info({
            message: "Information",
            description: err.response.data.message
          });
        });
    },

    getPeople(page) {
      this.loading = true;

      const params = {};
      if (this.searchLocation) params.location = this.searchLocation;
      if (this.searchGender) params.gender = this.searchGender;
      if (this.searchUserName) params.username = this.searchUserName;
      if (this.searchAge) params.age = this.searchAge;
      if (this.ibs) params.disease_type = this.ibs;
      params.page_num = page;
      params.items = this.limit;
      params.circle_id = this.currentCircle.id;

      AppRepository.memberSearch(
        this.currentPage,
        this.limit,
        this.currentCircle.id,
        params
      )
        .then(res => {
          if (res.data.data) {
            this.loading = false;
            this.peopleList = res.data.data.data;
            this.count = res.data.data.paginator.total_count;
            this.currentPage = Number(res.data.data.paginator.page_num);
            this.showFilters = true;
          } else {
            this.peopleList = [];
          }
        })
        .catch(err => {
          this.loading = false;
        });
    }
  }
};
</script>

<style lang="scss" scoped>
.meet-others {
  display: flex;
  align-items: center;
  button {
    margin-right: 24px;
    font-size: 14px;
    border-radius: 6px;
    padding: 12px 24px;
    width: 126px;
    height: 48px;
    font-family: 'Lato';
font-style: normal;
font-weight: 700;
  }
}
.results {
  font-size: 20px;
  color: #0F1734;
  font-family: 'Lato';
font-style: normal;
font-weight: 700;
font-size: 20px;
line-height: 30px;
}
.search-field {
  background: #f1f5f9;
  border-radius: 8px;
  border: none;
  margin-right: 24px;
}
.signup-page {
  padding: 70px;
}
.divider {
  height: 159px;
  border: 1px solid #CBD5E1;
  margin-top:-16px;
  background:#CBD5E1 ;
  margin-left: 35.5px;
} 
.search-container {
  display: flex;

  .search-input {
    padding: 10px;
    border-radius: 8px 0 0 8px;
    width: 95%;

    &:focus {
      outline: none;
    }
  }
  display: flex;
  align-items: center;
  .search-input-state {
    border-left: 0 !important;
    padding: 10px;
    width: 320px;

    &:focus {
      outline: none;
    }
  }
  .dropdownOptions {
    margin-right: 154px;
  }

  .search-button {
    max-width: 100px;
    border-radius: 0 8px 8px 0;
    padding: 11px;

    @media screen and (max-width: 900px) {
      padding: 6px;
    }

    &:focus {
      outline: none;
    }
  }
}

.input-placeholder {
  min-width: unset;

  &.male {
    border-radius: 20px 0 0 20px;
  }

  &.female {
    border-radius: 0 0 0 0;
    margin-left: -5px;
  }
  &.other {
    border-radius: 0 20px 20px 0;
    margin-left: -5px;
  }
}

.claim-card {
  border:  1px solid #E2E8F0;
  width: 100%;
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 0 15px rgba(0, 0, 0, 0.1);
  .user-name {
    height:159px;
    .bg-img {
      position: relative;
      // border: 1px solid #ccc;
      // min-width: 100px;
      max-width: 100px;
      min-height: 100px;
      max-height: 100px;
      border-radius: 50%;
      display: inline-block;
      margin-top: 24px;
     margin-left: 35.5px;
    
      .rating-badge {
        position: absolute;
        bottom: 0;
        left: 50%;
        transform: translate(-50%, 20%);
        font-size: 15px;
        border-radius: 20px;
        width: 55%;
      }
    }
  }

  .user-address {
    line-height: 15px;
  }

  .dovemed-card-footer {
    border-top: 1px solid rgba(0, 0, 0, 0.125);

    span {
      font-size: 12px;
    }
  }
}

.claim-modal-header {
  border-radius: 5px 5px 0 0;
  min-height: 100px;
  display: block;
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;

  .profile-img {
    min-width: 150px;
    max-width: 150px;
    min-height: 150px;
    max-height: 150px;
    display: block;
    border-radius: 50%;
    position: absolute;
    bottom: 0;
    left: 50%;
    transform: translate(-50%, 50%);
    box-shadow: 0px 5px 7px 0px rgba(0, 0, 0, 0.4);
  }
}

.profile-details {
  padding-top: 170px;
  max-width: 60%;
  margin: auto;
}

.terms-modal-container {
  padding: 30px;
  text-align: center;
}

.background-image {
  background-position: center !important;
  background-size: contain !important;
  background-repeat: no-repeat !important;
}

.filters-cont {
  transition: height 0.3s ease-in-out;
}

.transparent {
  opacity: 0;
  display: none;
}

.no-results-container {
  background: rgb(246, 246, 246);
  padding: 20px;
  border-radius: 8px;
}
@media screen and (max-width: 581px) {
  .search-input-state {
    width: 100%;
  }
  .filters-cont {
    .filter-content {
      display: flex;
      flex-direction: column;
    }
    .input-placeholder {
      padding: 8px 8px;
    }
  }
}

.right-items {
  display: flex;
  width: 100%;
  justify-content: space-between;
  overflow: none !important;
  margin-left: 24px;

  @media screen and (max-width: 900px) {
    display: block;
  }

  @media screen and (max-width: 600px) {
    display: block;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/home/meetothers/MeetPeople.vue